module.exports = __webpack_public_path__ + "static/wood-b9521f0f100d6da7243e189ddafc80de.jpg";